import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { NavLink } from 'react-router-dom'
import { useHistory } from "react-router-dom";
import Button from '../../Button';

function Superseria(props) {
  const [answer_a, setAnswer_a] = useState(false);
  const [answer_b, setAnswer_b] = useState(false);
  const [answer_c, setAnswer_c] = useState(false);
  const history = useHistory();

  let validate = (e) => {
    e.preventDefault()

  }

  return (
    <div className="page activation-page">
      <section>
          <div className="page-header">
            <h1>Cześć { props.user.user ? props.user.user.firstName : "" }</h1>
            <p>Poznajmy się lepiej – uzupełnij swój profil i zgarnij dodatkowe 5 zł do wypłaty już po pierwszym sprzedanym urządzeniu!</p>
            <p><NavLink to="/profil">Uzupełnij Profil</NavLink></p>
          </div>
        </section>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { screen, user, activations } = state
  return { screen, user, activations }
};

export default withRouter(connect(
  mapStateToProps,
  {

  }
)(Superseria));